module.exports = __webpack_public_path__ + "img/car-1.dc53c10a.png";